'use client';

import clsx from 'clsx';
import { Heading2 } from '@/components/section/headings';
import type { HomeTechCategory } from '@/constants/homeMarketing';
import { H3, Span, SURFACE_REVEAL, cn } from '@/components/ui';

export type HomeTechStackSectionProps = {
  title: string;
  subtitle?: string;
  categories: readonly HomeTechCategory[];
  sectionId?: string;
  className?: string;
};

/** Technology categories as read-only chip groups (design-system glass panel). */
const HomeTechStackSection: React.FC<HomeTechStackSectionProps> = ({
  title,
  subtitle,
  categories,
  sectionId,
  className,
}) => (
  <section
    id={sectionId}
    className={clsx('container-section', className)}
    aria-labelledby="home-tech-heading"
  >
    <div className="page-heading-wrap" id="home-tech-heading">
      <Heading2
        title={title}
        subtitle={subtitle}
        titleClassName="text-prose"
        subtitleClassName="mt-3 text-prose-muted"
      />
    </div>
    <div className="page-grid-tech">
      {categories.map((cat) => (
        <div
          key={cat.label}
          className={cn('page-glass-panel page-glass-panel--elevated', SURFACE_REVEAL)}
        >
          <H3 className="m-0 text-sm font-semibold uppercase tracking-wide text-prose-muted">
            {cat.label}
          </H3>
          <ul className="page-chip-list">
            {cat.tags.map((tag) => (
              <li key={tag}>
                <Span className="page-chip">
                  {tag}
                </Span>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  </section>
);

export default HomeTechStackSection;
